module.exports = __webpack_public_path__ + "img/three2Blue.5a229da5.jpg";